import { render, staticRenderFns } from "./CheckOrganizerSetup.vue?vue&type=template&id=fa0014c0&scoped=true&"
import script from "./CheckOrganizerSetup.vue?vue&type=script&lang=js&"
export * from "./CheckOrganizerSetup.vue?vue&type=script&lang=js&"
import style0 from "./CheckOrganizerSetup.vue?vue&type=style&index=0&id=fa0014c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0014c0",
  null
  
)

export default component.exports